import { useEffect, Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { AudioProvider } from './AudioContext'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import RecruitBanner from './components/RecruitBanner'
import PlayerBar from './components/PlayerBar'
import Home from './pages/Home'

const Radio = lazy(() => import('./pages/Radio'))
const Planning = lazy(() => import('./pages/Planning'))
const Equipe = lazy(() => import('./pages/Equipe'))
const Dedicaces = lazy(() => import('./pages/Dedicaces'))
const Request = lazy(() => import('./pages/Request'))
const MentionsLegales = lazy(() => import('./pages/MentionsLegales'))
const Integrations = lazy(() => import('./pages/Integrations'))
const Contact = lazy(() => import('./pages/Contact'))
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'))
const NotFound = lazy(() => import('./pages/NotFound'))

function PageLoader() {
  return (
    <div className="page-loader">
      <div className="page-loader__spinner" />
    </div>
  )
}

function AppLayout() {
  const { pathname } = useLocation()
  const isHome = pathname === '/'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Navbar />
      <main className="content-wrap">
        <RecruitBanner />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/planning" element={<Planning />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/dedicaces" element={<Dedicaces />} />
            <Route path="/request" element={<Request />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
      </main>
      {!isHome && <PlayerBar />}
    </>
  )
}

export default function App() {
  return (
    <AudioProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppLayout />
      </BrowserRouter>
    </AudioProvider>
  )
}
